import request from '@/utils/request'

const regions = (idParent) => {
  return request({
    url: '/open/regions',
    params: idParent,
    method: 'get'
  })
}

const regionsDetail = (id) => {
  return request({
    url: `/open/regions/${id}`,
    method: 'get'
  })
}

export {
  regions, // 查询地址列表信息
  regionsDetail // 获取地址详情，会将父级信息同时返回
}
